import React from "react";

interface IProps {
	name: string;
	checked: boolean;
	prop: string;

	changeEvent: (e: any) => void;

	//Only for roadmaps
	toggleDarkModeSpecial?: (e: any) => void;
}

//Compatibility restricted to SettingsForm only
export default class ButtonSwitch extends React.Component<IProps> {
	render() {
		const name = this.props.name;
		
		return (
			this.props.toggleDarkModeSpecial ? (
				<p className="btn-switch">
					<input type="radio"
						id={"yes" + name}
						name={"switch" + name}
						className="btn-switch__radio btn-switch__radio_yes"
						checked={this.props.checked}
						onChange={this.props.changeEvent}
						/>
					<input type="radio"
						id={"no" + name}
						name={"switch" + name}
						className="btn-switch__radio btn-switch__radio_no"
						checked={!this.props.checked}
						onChange={this.props.changeEvent}
						/>
					<label htmlFor={"yes" + name} className="btn-switch__label btn-switch__label_yes"><span className="btn-switch__txt">&nbsp;</span></label>
					<label htmlFor={"no" + name} className="btn-switch__label btn-switch__label_no"><span className="btn-switch__txt">&nbsp;</span></label>
				</p>
			) : (
				<p className="btn-switch">
					<input type="radio"
						id={"yes" + name}
						name={"switch" + name}
						className="btn-switch__radio btn-switch__radio_yes"
						
						{...{prop: this.props.prop}}

						checked={this.props.checked}
						onChange={this.props.changeEvent}
						/>
					<input type="radio"
						id={"no" + name}
						name={"switch" + name}
						className="btn-switch__radio btn-switch__radio_no"
						{...{prop: this.props.prop}}
						checked={!this.props.checked}
						onChange={this.props.changeEvent}
						/>
					<label htmlFor={"yes" + name} className="btn-switch__label btn-switch__label_yes"><span className="btn-switch__txt">&nbsp;</span></label>
					<label htmlFor={"no" + name} className="btn-switch__label btn-switch__label_no"><span className="btn-switch__txt">&nbsp;</span></label>
				</p>
			)
		);
	}
}